import type {
  IDecimalValueAndUnit,
  ISpreadingJobFieldUpdate,
  ISpreadingJobUpdateForm
} from '@/interfaces'
import Base from '../Base'
import { DirectionUnitLabelType, TemperatureUnitLabelType, type JobStatusType } from '@/enum'
import SpreadingJobFieldUpdate from './SpreadingJobFieldUpdate'
import DecimalValueAndUnit from '../DecimalValueAndUnit'
import moment from 'moment'

class SpreadingJobUpdateForm extends Base implements ISpreadingJobUpdateForm {
  status: JobStatusType
  description: string | null
  scheduleDate: string | null
  preAssessmentTime: string | null
  spreadingTime: string | null
  windSpeed: IDecimalValueAndUnit | null
  windDirection: string | null
  cloudCondition: string | null
  temperature: IDecimalValueAndUnit | null
  fieldCondition: string | null
  farmId: string | null
  field: ISpreadingJobFieldUpdate | null
  siloId: string | null
  assignedEmployeeId: string | null
  assignedVehicleId: string | null
  notes: string | null

  constructor(data?: ISpreadingJobUpdateForm) {
    super(data)
    this.status = data?.status ?? 0
    this.description = data?.description ?? null
    this.scheduleDate = data?.scheduleDate ?? null
    this.preAssessmentTime = data?.preAssessmentTime ?? moment().format('HH:mm:ss');
    this.spreadingTime = data?.spreadingTime ?? null
    this.windSpeed = data?.windSpeed
      ? this.checkWindSpeed(data?.windSpeed)
      : new DecimalValueAndUnit({ value: 0, unit: DirectionUnitLabelType.MILESPERHR })
    this.windDirection = data?.windDirection ?? null
    this.cloudCondition = data?.cloudCondition ?? null
    this.temperature = data?.temperature
      ? this.checkTemprature(data?.temperature)
      : new DecimalValueAndUnit({ value: 0, unit: TemperatureUnitLabelType.CELSIUS })
    this.fieldCondition = data?.fieldCondition ?? null
    this.farmId = data?.farmId ?? null
    this.field = data?.field ? new SpreadingJobFieldUpdate(data.field) : null
    this.siloId = data?.siloId ?? null
    this.assignedEmployeeId = data?.assignedEmployeeId ?? null
    this.assignedVehicleId = data?.assignedVehicleId ?? null
    this.notes = data?.notes ?? null
  }

  private mapFields(fields: ISpreadingJobFieldUpdate[]): SpreadingJobFieldUpdate[] {
    return fields.map((field) => new SpreadingJobFieldUpdate(field))
  }

  private checkWindSpeed(windSpeed: IDecimalValueAndUnit | null) {
    if (windSpeed && windSpeed.value) {
      return windSpeed
    }
    return new DecimalValueAndUnit({ value: 0, unit: DirectionUnitLabelType.MILESPERHR })
  }

  private checkTemprature(temp: IDecimalValueAndUnit | null) {
    if (temp && temp.value) {
      return temp
    }
    return new DecimalValueAndUnit({ value: 0, unit: TemperatureUnitLabelType.CELSIUS })
  }
}

export default SpreadingJobUpdateForm
